import React from 'react';
import heroImage from '../assets/images/hero1.jpg';

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-emerald-50 via-white to-emerald-100">
      <div className="absolute -left-32 top-24 h-72 w-72 rounded-full bg-emerald-200/40 blur-3xl" />
      <div className="absolute -right-20 -top-20 h-96 w-96 rounded-full bg-emerald-300/30 blur-3xl" />
      <div className="relative mx-auto flex max-w-6xl flex-col-reverse items-center gap-16 px-6 py-24 lg:flex-row lg:items-center">
        <div className="max-w-xl space-y-6 text-center lg:text-left">
          <span className="inline-flex items-center rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-emerald-700">
            Call • Confirm • Deliver
          </span>
          <h1 className="text-4xl font-bold leading-tight text-slate-900 sm:text-5xl">
            Dial TPR brings neighbourhood shops to your doorstep
          </h1>
          <p className="text-lg text-slate-600">
            A single phone call is all it takes. We note your list, coordinate with trusted local stores, confirm the shop invoice, and our delivery executive brings everything to you with complete transparency.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 lg:justify-start">
            <a
              href="tel:+919176126422"
              className="inline-flex items-center rounded-full bg-emerald-500 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-emerald-200 transition hover:-translate-y-0.5 hover:bg-emerald-600"
            >
              Call to Order
            </a>
            <a
              href="https://wa.me/919176687956"
              className="inline-flex items-center rounded-full border border-emerald-500 px-6 py-3 text-sm font-semibold text-emerald-600 transition hover:bg-emerald-50"
            >
              WhatsApp Your List
            </a>
          </div>
          <dl className="grid grid-cols-2 gap-6 pt-8 text-left sm:grid-cols-4">
            {[{ label: 'Partner Shops', value: '20+' }, { label: 'Avg. Fulfilment', value: '30 mins' }, { label: 'Delivery Executives', value: '5' }, { label: 'Repeat Customers', value: '1000+' }].map((item) => (
              <div key={item.label} className="rounded-2xl border border-emerald-100 bg-white/60 p-4 shadow-sm shadow-emerald-100/60 backdrop-blur">
                <dt className="text-xs font-semibold uppercase tracking-wide text-emerald-600">{item.label}</dt>
                <dd className="mt-1 text-xl font-bold text-slate-900">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="relative w-full max-w-md">
          <div className="absolute inset-0 -translate-x-6 translate-y-6 rounded-3xl bg-emerald-200/40 blur-xl" />
          <div className="relative overflow-hidden rounded-3xl border border-white/60 shadow-xl shadow-emerald-200/60">
            <img src={heroImage} alt="Courier delivering local orders" className="h-full w-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
